import { Box } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { COLORS } from '@/styles/tokens/colors';

export interface AcceptRejectToolbarButtonsProps {
  onAccept: () => void;
  onReject: () => void;
  /** Explicit data-testid for the Reject button. Pass when external tests
   *  (E2E or otherwise) need to select the button by a specific id. */
  rejectDataTestId?: string;
  /** Explicit data-testid for the Accept button. */
  acceptDataTestId?: string;
}

/**
 * A divider + Reject + Accept button pair for use inside a slide toolbar.
 *
 * Renders three sibling elements (vertical divider, Reject button, Accept
 * button) intended to sit at the end of a `SlideToolbar` row. Used by the
 * presentation diagram editor's regenerate flow and by the slide rich-text
 * editor's post-generate accept/reject flow.
 */
export function AcceptRejectToolbarButtons({
  onAccept,
  onReject,
  rejectDataTestId,
  acceptDataTestId,
}: AcceptRejectToolbarButtonsProps) {
  return (
    <>
      <Box sx={{ width: '1px', height: 16, bgcolor: COLORS.GRAY[200] }} />
      <Button
        size="xs"
        variant="destructive-transparent"
        data-testid={rejectDataTestId}
        onClick={onReject}
        sx={{ borderRadius: '4px', px: 1, py: 0.5 }}
      >
        Reject
      </Button>
      <Button
        size="xs"
        variant="primary"
        data-testid={acceptDataTestId}
        onClick={onAccept}
        sx={{ borderRadius: '4px', px: 1, py: 0.5 }}
      >
        Accept
      </Button>
    </>
  );
}
